/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * The generic types for actions
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.0.0
 */

export interface IAction<T extends string> {
    type: T;
}

export interface IActionWithPayload<T extends string, P> extends IAction<T>{
    payload: P;
}

export interface IActionWithOptionalPayload<T extends string, P> extends IAction<T>{
    payload?: P;
}

export interface IActionError<T extends string> extends IAction<T>{
    payload: string;
}

export function createAction<T extends string>(type: T): IAction<T>
export function createAction<T extends string, P>(type: T, payload: P): IActionWithPayload<T, P>
export function createAction<T extends string, P>(type: T, payload?: P) {
    return payload === undefined ? { type } : { type, payload };
}
